import React from "react";

const Files=({data})=>{
    return(
        <div className="container">
        <div className="row row-cols-3">        
        <>
        {            
            data && data.map((d)=>{
                return(
                    <div className="col">
                    <a href={d.weblink} id={d.id} target="_blank">{d.monthName} of {d.yearNum}</a>
                    </div>
                )
            })
        }
        </>
        </div>
        </div>
    )
}

export default Files;